export default __webpack_public_path__ + "static/media/tourDetailPage.f9076491.jpg";